import styles from './SubscriptionLabel.module.css';

export const SubscriptionLabel = ({ label }: { label: string }) => (
  <div className={`${styles.label} ${styles[label.toLowerCase()]}`}>{label.toUpperCase()}</div>
);
